import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	// 重定向
	{
		path: '',
		redirect: '/home',
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import(/* webpackChunkName:'home'*/ 'views/home/Home.vue'),
	},
	{
		path: '/detail',
		name: 'Detail',
		component: () => import(/* webpackChunkName:'detail'*/ 'views/detail/Detail.vue'),
		// props:true
	},
	{
		path: '/goodDetail',
		name: 'goodDetail',
		component: () => import(/* webpackChunkName:'detail'*/ 'views/goodDetail/index.vue'),
		// props:true
	},
	{
		path: '/sortPage',
		name: 'sortPage',
		component: () => import(/* webpackChunkName:'detail'*/ 'views/sortPage/index.vue'),
	},
	{
		path: '/express',
		name: 'express',
		component: () => import(/* webpackChunkName:'detail'*/ 'views/express/index.vue'),
	},
	{
		path: '/paypalDetail',
		name: 'paypalDetail',
		component: () => import('components/payWay/paypal/paypalDetail.vue'),
	},
	{
		path: '/CardPaySuccess',
		name: 'CardPaySuccess',
		component: () => import(/* webpackChunkName:'detail'*/ '@/components/payWay/CardPaySuccess.vue'),
	},
	// {
	//   path: '/server',
	//   name: 'Server',
	//   component: () => import( 'views/server/Server.vue'),
	//   redirect:'/server/service',
	//   children:[
	//     {path:'discount',name:'Discount',component: () => import('views/server/serverChild/Discount.vue') },
	//     {path:'service',name:'Service',component: () => import('views/server/serverChild/Service.vue') },
	//     {path:'serverlist',name:'ServerList',component: () => import('views/server/serverChild/ServerList.vue') },
	//     {path:'increment',name:'Increment',component: () => import('views/server/serverChild/Increment.vue') },
	//     {path:'demo',name:'Demo',component:()=>import('views/server/serverChild/demo.vue')}
	//   ]
	// }
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
})

export default router
